// MachineUtilizationDashboard/utils/machineDashboardUtils.js

export const BRAND = {
  primary: "#053c83",
  secondary: "#2f539d",
  success: "#16a34a",
  warning: "#f59e0b",
  danger: "#ef4444",
  info: "#0891b2",
  purple: "#7c3aed",
  slate: "#64748b",
};

export const safeNumber = (value, fallback = 0) => {
  const number = Number(value);

  return Number.isFinite(number) ? number : fallback;
};

export const round = (value, decimals = 2) => {
  const number = safeNumber(value);
  const multiplier = 10 ** decimals;

  return Math.round(number * multiplier) / multiplier;
};

export const formatNumber = (value, decimals = 0) => {
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  }).format(safeNumber(value));
};

export const formatPercentage = (value, decimals = 2) => {
  return `${formatNumber(value, decimals)}%`;
};

export const getUtilizationLevel = (value) => {
  const percentage = safeNumber(value);

  if (percentage >= 100) {
    return {
      key: "exceeded",
      label: "Target Exceeded",
      tone: "purple",
    };
  }

  if (percentage >= 75) {
    return {
      key: "high",
      label: "High",
      tone: "success",
    };
  }

  if (percentage >= 40) {
    return {
      key: "medium",
      label: "Medium",
      tone: "warning",
    };
  }

  if (percentage > 0) {
    return {
      key: "low",
      label: "Low",
      tone: "danger",
    };
  }

  return {
    key: "none",
    label: "No Runtime",
    tone: "neutral",
  };
};

export const getStatusClass = (status) => {
  const normalizedStatus = String(status || "").toUpperCase();

  if (normalizedStatus === "RUNNING") return "running";
  if (normalizedStatus === "IDLE") return "idle";

  return "stopped";
};

export const getSeverityClass = (severity) => {
  const value = String(severity || "").toUpperCase();

  if (value === "CRITICAL") return "critical";
  if (value === "WARNING") return "warning";

  return "info";
};

export function normalizeHeatMap(data) {
  if (!data) {
    return {
      hours: [],
      machines: [],
    };
  }

  return {
    hours: Array.isArray(data?.hours)
      ? data.hours
      : [],

    machines: Array.isArray(data?.rows)
      ? data.rows
      : Array.isArray(data?.machines)
        ? data.machines
        : [],
  };
}

export const getMachineHeatMapData = (data) => {
  return (
    data?.utilizationHeatMap ||
    null
  );
};

export const truncateText = (text, maxLength = 24) => {
  const value = String(text || "");

  if (value.length <= maxLength) return value;

  return `${value.slice(0, maxLength)}...`;
};